import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { applyDynamicsToHtml } from "@devowl-wp/headless-content-unblocker";
import { CookieProperty } from "./cookieProperty.js";
import { useDurationText } from "../../../hooks/common/useDurationText.js";
import { useBannerOrBlocker } from "../../../hooks/useBannerOrBlocker.js";
const CookiePropertyTechnicalDefinitionsTable = ({ definitions: definitions, codeDynamics, printValueAs })=>{
    const { i18n } = useBannerOrBlocker();
    const generateDurationText = useDurationText();
    const types = getCookieTypeLocalizationMap();
    return definitions?.map(({ children, type, name, host, duration, durationUnit, isSessionDuration, purpose, description })=>/*#__PURE__*/ _jsxs(CookieProperty, {
            label: i18n.technicalCookieName,
            monospace: true,
            value: applyDynamicsToHtml(name, codeDynamics),
            printValueAs: printValueAs,
            children: [
                /*#__PURE__*/ _jsx(CookieProperty, {
                    label: i18n.type,
                    value: types[type]?.name || type,
                    printValueAs: printValueAs
                }),
                !!host && /*#__PURE__*/ _jsx(CookieProperty, {
                    label: i18n.host,
                    value: host,
                    monospace: true,
                    printValueAs: printValueAs
                }),
                !!description && /*#__PURE__*/ _jsx(CookieProperty, {
                    label: i18n.description,
                    value: description,
                    printValueAs: printValueAs
                }),
                /*#__PURE__*/ _jsx(CookieProperty, {
                    label: i18n.duration,
                    value: [
                        "local",
                        "indexedDb"
                    ].indexOf(type) > -1 ? i18n.noExpiration : isSessionDuration || type === "session" ? "Session" : generateDurationText(duration, durationUnit)
                }),
                children,
                /*#__PURE__*/ _jsx(CookieProperty, {
                    label: i18n.purpose,
                    value: purpose,
                    printValueAs: printValueAs
                })
            ]
        }, `${type}-${name}-${host}`));
};
function getCookieTypeLocalizationMap() {
    return {
        http: {
            name: "HTTP Cookie",
            abbr: "HTTP",
            backgroundColor: "black"
        },
        local: {
            name: "Local Storage",
            abbr: "Local",
            backgroundColor: "#b3983c"
        },
        session: {
            name: "Session Storage",
            abbr: "Session",
            backgroundColor: "#3c99b3"
        },
        indexedDb: {
            name: "IndexedDB",
            abbr: "I-DB",
            backgroundColor: "#4ab33c"
        }
    };
}
export { CookiePropertyTechnicalDefinitionsTable, getCookieTypeLocalizationMap };
